export default __webpack_public_path__ + "static/media/loading-3.c76ae7b1.jpeg";